import { greyScale, applyOpacityToHex, colorScale } from 'themes/defaultColors';

const oceanBlue = '#00b045';
const pastelRed = '#da6561';

const colors = {
  primary: {
    light: '#1f93db',
    main: '#1f6bb1',
    dark: '#1a4985',
  },
  secondary: {
    light: '#74b8ff',
    main: '#2989ff',
    dark: '#004eae',
  },
  error: {
    main: '#eaa111',
  },
  text: {
    primary: '#3e3e3c',
    secondary: '#706e6b',
    disabled: '#c9c7c5',
    lightContrast: greyScale[7],
  },
  other: {
    quickTips: '#ef7d5b',
    overdueTxn: '#f29d50',
    dueTxn: '#1f599e',
  },
};

// -- THIS EXPORT SHOULD NOT BE USED EXCEPT IN 'themeBase.js' -- //
export const theme = {
  project: 'Quicken',
  palette: {
    ...colors,
    ...colorScale,
    data: {
      sequence1: ['#5cb3ea', '#ffee00', '#5ac402', '#ff8000', '#7d6fc4', '#ff3e7a', '#79d5e0', '#9b91c5', '#08a2b5', '#f1635f'],
    },
    background: {
      default: '#f7f7f7',
    },
    greyScale,
  },
  defaults: {},
  // override specific component styles for Quicken theme, colors should be referenced from the 'colors' object above,
  //    ----- ONLY in special cases should there be hex codes below here -----
  components: {
    appBar: {
      color: colors.text.primary,
      borderRadius: 0,
      opacity: 1,
      borderBottom: `1px solid ${greyScale[4]}`,
      boxShadow: 'none',
      background: greyScale[7],
      zIndex: 1,
      height: 70,
      position: 'sticky',
      display:'flex',
    },
    featureHeader: {
      titleVariant: 'h6',
      subTitleVariant: 'subtitle1',
    },
    toolBar: {
      height: 70,
      paddingLeft: 32,
      paddingRight: 32,
      width:'100%',
      display:'flex',
      justifyContent:'space-between',
    },
    register: {
      transferDelimeter1: '[',
      transferDelimeter2: ']',
      fieldMargin: 8,

      pendingTextColor: '#4a90e2',
      pendingRowColor: '#f5faff',

    },
    accountCard: {
      background: colors.primary.main,
    },
    accountDrawer: {
      // -- Sizing -- //
      width: 280,
      accountListBaseFontSize: 14.5,
      drawerListTitleFontSize: '17px',

      basePadding: 16,
      listPaddingLeft: 16,
      listPaddingRight: 28,

      accountListLevelIndent: 4,
      iconSize: 20,

      // -- Text colors -- //
      // positiveBalance: null,
      highlightText: greyScale[7], // total + net-worth
      textColor: greyScale[7], // banking + investments
      headerListText: greyScale[7], // accounts bar
      l2TextColor: applyOpacityToHex(greyScale[7], 0.93),
      l3TextColor: applyOpacityToHex(greyScale[7], 0.88),
      negativeBalance: '#ffb7b5',

      // -- Background colors -- //
      background: '#1f6bb1',
      highlightColor: 'rgba(255, 255, 255, 0.15)', // selected account
      // hoverColor: null, // hover effect
      // l1Color: null, // banking + investments
      logoBackground: '#678fe81a',
      headerBackground: '#1f74ba',

      // other colors
      borderColor: '#1e69ac', // right-side border
      divider: '#1e69ac', // border of collapse button
      openControl: '#fafaf9',  // background inside collapse button,
      icon: '#1f74ba',  // icon inside collapse button,

      actionColor: greyScale[7], // add-FI button color
      // actionBackground: colorScale.others.link, // add-FI button background
      actionButtonSize: 40,

      // row sizing
      l1Margin: 0,
      l0Height: 37,
      l1Height: 52,
      l2Height: 34,
      l3Height: 32,
    },
    navigation: {
      headerColor: '#1F74BA',
      barWidthOpen: 206,
      rowOpacity: 1,
      selectedBackground: applyOpacityToHex(greyScale[0], 0.3),
      hoverBackground: applyOpacityToHex(greyScale[0], 0.2),
      iconColor: '#d5e6f1',
      selectedIconColor: '#d5e6f1',
      iconHoverColor: '#d5e6f1',
      textColor: '#d5e6f1',
      selectedTextColor: '#d5e6f1',
    },
    spendingOverTime: {
      positiveDefault: oceanBlue,
      positiveDimmed: '#C3E7C8',
      negativeDefault: '#cc6c65',
      negativeDimmed: '#F4D2D0',
    },
    incomeVersusSpending: {
      spendingPositiveDefault: pastelRed,
      spendingPositiveDimmed: applyOpacityToHex(pastelRed, .3),
      spendingNegativeDefault: '#cc6c65',
      spendingNegativeDimmed: applyOpacityToHex('#cc6c65', .3),
      incomePositiveDefault: oceanBlue,
      incomePositiveDimmed: applyOpacityToHex(oceanBlue, 0.3),
    },
    netIncome: {
      positiveDefault: oceanBlue,
      positiveDimmed: '#C3E7C8',
      negativeDefault: pastelRed,
      negativeDimmed: '#F4D2D0',
    },
    income: {
      positiveDefault: oceanBlue,
      positiveDimmed: '#C3E7C8',
      negativeDefault: pastelRed,
      negativeDimmed: '#F4D2D0',
    },
    qCards: {
      backgroundColor: '#1d53b5',
      titleColor: '#fff486',
      contentColor: '#FFF',
      closeColor: '#FFF',
      highlightColor: '#84def3',
      buttonTextColor: '#fff486',
    },
    categoryCard: {
      barChartIconColor: colorScale.color9.opacity100,
      tabBackgroundSelected: 'white',
      tabBackground: applyOpacityToHex('#1F74BA', .8),
      tabTextColorSelected: greyScale[1],
      tabTextColor: 'white',
    },
  },
  overrides: {
    MuiFormLabel: {
      root: {
        '&.Mui-focused': {
          color: colors.secondary.light,
        },
      },
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottomColor: colors.secondary.light,
        },
      },
    },
  },
};
